import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { SnackBarService } from "src/app/shared";
import { NotificationService } from "../../services/notification.service";
import { DomSanitizer } from "@angular/platform-browser";
import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ name: "safeHtml" })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
@Component({
  selector: "app-events",
  templateUrl: "./events.component.html",
  styleUrls: ["./events.component.scss"],
})
export class EventsComponent implements OnInit {
  displayedColumns = ["number", "title", "subject", "type", "status", "action"];
  eventsList: any;
  event: any;

  pageSizeOptions: number[] = [20, 50, 100, 200, 500];
  pageSize: number = this.pageSizeOptions[0];
  pageOffset: number = 0;
  pageIndex: number = 0;
  @ViewChild("broadCast", { static: false }) broadCast: any;
  @ViewChild("detail", { static: false }) detail: any;
  @ViewChild("broadcastNewEvent", { static: false }) broadcastNewEvent: any;
  newEvent: number;

  constructor(
    private notificationService: NotificationService,
    private snackBarService: SnackBarService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.getNotificationEvents();
  }

  getNotificationEvents(reset: boolean = false) {
    if (reset) {
      this.pageOffset = 0;
      this.pageIndex = 0;
    }
    let filters = {
      limit: this.pageSize,
      offset: this.pageOffset,
      ordering: "-id",
    };
    this.notificationService.getEventsList(filters).subscribe((res) => {
      this.eventsList = res;
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params["event"]) {
          this.newEvent = params["event"];
          let dialogRef = this.dialog.open(this.broadcastNewEvent);
          dialogRef.afterClosed().subscribe((result) => {
            this.router.navigate(["/notifications/events"]);
          });
        }
      });
    });
  }

  onPaginationChange(e) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.pageOffset = this.pageIndex * this.pageSize;
    this.getNotificationEvents();
  }

  broadCastMessage(eventId) {
    let dialogRef = this.dialog.open(this.broadCast);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialog.closeAll();
      if (result) {
        this.notificationService.broadCastMessage(eventId).subscribe(
          (success) => {
            this.snackBarService.showSnack(
              "notification event broadcasted successfuly."
            );
            this.getNotificationEvents();
          },
          (error) => {
            this.snackBarService.showSnack(error.error.detail);
          }
        );
      }
    });
  }

  resendCampaign(event_id: number) {
    this.notificationService.getEventDetails(event_id).subscribe((data) => {
      this.router.navigate(["/notifications", "events", "create-event"], {
        state: data,
      });
    });
  }

  getEventDetails(event_id: number) {
    this.notificationService.getEventDetails(event_id).subscribe((data) => {
      this.event = data;
      this.dialog.open(this.detail, { autoFocus: false, maxHeight: "90vh" });
    });
  }
}
